import React from 'react';
import PropTypes from 'prop-types';


export const BrandLogos = (props) => {
    const {
        headline,
        logos,
        closingCopy
    } = props;

    // eslint-disable-next-line arrow-body-style
    const renderLogos = (pics) => {
        return pics.map(pic => <img key={pic.url} loading="lazy" src={pic.url} alt={pic.alt} width="224" height="140" />);
    };

    return (
        <div className="ulx__aem-section ulx__aem-brand-logos" id="Partnerships">
            <h2>{headline}</h2>
            <div className="ulx__aem-brand-logos__logos">{renderLogos(logos)}</div>
            <div>{closingCopy}</div>
        </div>

    );
};

BrandLogos.propTypes = {
    headline: PropTypes.string.isRequired,
    closingCopy: PropTypes.string.isRequired,
    logos: PropTypes.arrayOf(PropTypes.shape(
        {
            url: PropTypes.string.isRequired,
            alt: PropTypes.string.isRequired
        }
    )).isRequired
};

export default BrandLogos;
